export const purchaseSubscriptionMessages = [
  "in-sufficient credit",
  "already subscribed",
  "subscription is not available yet",
  "you do not have any default card yet to complete this purchase",
];
